import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SkillsProp {
  loading: boolean;
  data: [];
  status: number;
  // error:null| string
}

export const initialState: SkillsProp = {
  loading: false,
  data: [],
  status: 0,
  // error:null
};

const skillsListSlice = createSlice({
  name: "skillsList",
  initialState,
  reducers: {
    reset: () => initialState,
    skillsListRequest(state: SkillsProp, action: PayloadAction<any>) {
      state.loading = true;
    },
    skillsListSuccess(
      state: SkillsProp,
      action: PayloadAction<{ data: any; status: number }>,
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    skillsListFailure(state: SkillsProp) {
      state.loading = false;
      // state.error = action.payload;
    },
  },
});

export const skillsListAction = skillsListSlice.actions;
export const skillsListReducer = skillsListSlice.reducer;

export default skillsListReducer;
